<template>
  <detail-page-layout :config="pageConfig">
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[Data]" v-if="Data.State === 'draft' || Data.State === 'cancelled'">
     <el-table-column type="expand" >
        <template scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="收件人：">
              <span>{{ props.row.ContactName }}</span>
            </el-form-item>
            <el-form-item label="联系人电话：">
              <span>{{ props.row.ContactPhone }}</span>
            </el-form-item>
           <el-form-item label="联系地址：" v-if="props.row.StreetAddress === null">
                <span>{{ props.row.Province?props.row.Province.Name:'-' }} {{ props.row.City?props.row.City.Name:'-' }} {{ props.row.County?props.row.County.Name:'-' }} {{  props.row.PointOfSales.Name }}</span>
              </el-form-item>
              <el-form-item label="联系地址：" v-if="props.row.StreetAddress !== null">
                <span>{{ props.row.Province?props.row.Province.Name:'-' }} {{ props.row.City?props.row.City.Name:'-' }} {{ props.row.County?props.row.County.Name:'-' }} {{  props.row.StreetAddress }}</span>
              </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="物流订单" prop="Code"></el-table-column>
      <el-table-column label="订单来源">
        <template scope="prop">
            <el-col>{{prop.row.OriginalOrderType | LogisticsSource}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="发货类型">
        <template scope="prop">
            <el-col>{{prop.row.DeliveryType | changeDeliveryType}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="物流费用" prop="TotalAmount"></el-table-column>
    </el-table>
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[Data]" v-if="Data.State === 'shipped' || Data.State === 'arrived'">
     <el-table-column type="expand">
        <template scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="收件人：">
              <span>{{ props.row.ContactName }}</span>
            </el-form-item>
            <el-form-item label="联系人电话：">
              <span>{{ props.row.ContactPhone }}</span>
            </el-form-item>
            <el-form-item label="联系地址：" v-if="props.row.StreetAddress === null">
              <span>{{ props.row.Province?props.row.Province.Name:' ' }} {{ props.row.City?props.row.City.Name:' ' }} {{ props.row.County?props.row.County.Name:' ' }} {{  props.row.PointOfSales?props.row.Name:'' }}</span>
            </el-form-item>
            <el-form-item label="联系地址：" v-if="props.row.StreetAddress !== null">
              <span>{{ props.row.Province?props.row.Province.Name:' ' }} {{ props.row.City?props.row.City.Name:' ' }} {{ props.row.County?props.row.County.Name:' ' }} {{  props.row.StreetAddress }}</span>
            </el-form-item>
            <el-form-item label="签收时间：" v-if="Data.State === 'arrived'">
              <span v-if="props.row.ReceivedDate !== null">{{ props.row.ReceivedDate | date('YYYY-MM-DD HH:mm:ss')}}</span>
              <span v-if="props.row.ReceivedDate === null">-</span>
            </el-form-item>
            <el-form-item label="等待时间：" v-if="Data.State === 'arrived'">
              <span>{{ props.row.WaitedHours}}分钟</span>
            </el-form-item>
            <el-form-item label="等待时间：" v-if="Data.State === null">
              <span>-</span>
            </el-form-item>
            <el-form-item label="备注：" v-if="Data.State === 'arrived'">
              <span>{{ props.row.ArrivalNotes | NullShow}}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="物流订单" prop="Code"></el-table-column>
      <el-table-column label="订单来源">
        <template scope="prop">
            <el-col>{{prop.row.OriginalOrderType | LogisticsSource}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="发货类型">
        <template scope="prop">
            <el-col>{{prop.row.DeliveryType | changeDeliveryType}}</el-col>
        </template>
      </el-table-column>
      <el-table-column
        label="发货时间"
        prop="ShippedDate"  min-width="120px">
        <template scope="props">{{props.row.ShippedDate | date('YYYY-MM-DD HH:mm:ss')}}</template>  
      </el-table-column>
      <el-table-column
        label="预约时间"
        prop="ScheduledDate" v-if="Data.State === 'shipped'  && Data.DeliveryType === 'scheduled' || Data.State === 'arrived' && Data.DeliveryType === 'scheduled' " min-width="120px">
        <template scope="props">{{props.row.ScheduledDate | date('YYYY-MM-DD HH:mm:ss')}}</template>  
      </el-table-column>
      <el-table-column label="物流费用" prop="TotalAmount"></el-table-column>
      <el-table-column
          label="配送方式"
          prop="Carrier">
          <template scope="props" v-if="props.row.Carrier">{{props.row.Carrier.Name}}</template>
        </el-table-column>
      <el-table-column
          label="配送员"
          prop="DeliveryEmployee.Name" >
        </el-table-column>
        <el-table-column
          label="配送员电话"
          prop="ContactPhone" >
        </el-table-column>
    </el-table>
    <h3 style="line-height: 3em;">物料清单</h3>
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="Data.Lines">
      <el-table-column label="批次号" prop="LotCode"></el-table-column>
      <el-table-column label="物料名称">
        <template scope="props">
            <el-col>{{props.row.Product.Name}}</el-col>
            <el-col>物料编码:{{props.row.Product.Code}}</el-col>
          </template>
      </el-table-column>
      <el-table-column label="品项">
        <template scope="props">
            <el-tag :type="props.row.Condition.Name | ConditionColor">{{props.row.Condition.Name}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="品牌" prop="Product.Brand.Name"></el-table-column>
      <el-table-column label="机型" prop="Product.Model.Name"></el-table-column>
      <el-table-column label="模块" prop="Product.Module.Name"></el-table-column>
    </el-table>
  </detail-page-layout>
</template>

<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import o from '@/odata'
export default {
  created() {
    this.getData()
  },
  data() {
    return {
      Data: {},
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          {key: 'receiving', title: '待发货'},
          {key: 'shipped', title: '发货中'},
          {key: 'finished', title: '已完成'},
        ],
        Step: 1,
        Breadcrumbs: [
          {
            to: {name: 'LogisticsList'},
            name: '物流订单列表',
          },
          {
            name: '物流订单',
          },
        ],
      },
      IsLoading: false,
      defaultSteps: [
        {key: 'receiving', title: '待发货'},
        {key: 'shipped', title: '发货中'},
        {key: 'finished', title: '已完成'},
      ],
    }
  },
  methods: {
     /* 获取订单详情 */
    getData() {
      this.IsLoading = true
      const id = this.$route.params.id
      o('DeliveryOrder').find(id).expand(`Customer($select=Id,Code,Name)`).expand(`Region($select=Id,Code,Name)`).expand(`Carrier($select=Id,Code,Name)`).expand(`DeliveryEmployee($select=Id,Name)`).expand(`PointOfSales($select=Id,Code,Name)`).expand(`Province($select=Id,Code,Name)`).expand(`City($select=Id,Code,Name)`).expand(`County($select=Id,Code,Name)`).expand(`Lines($expand=Product,Condition)`)
        .get()
        .then(({ data }) => {
          this.IsLoading = false
          this.Data = data
          this.updateSteps(data.State)
        }).catch((err) => {
          this.IsLoading = false
          let message
          switch (err.status) {
            case 404:
              message = '订单不存在'
              break
            default:
              message = `unkown error${err.status}`
          }
          this.$alert(message, 'Error!')
        })
    },
    updateSteps(State) {
      switch (State) {
        case 'draft':
        case 'confirmed':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 1)
          break
        case 'shipped':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 2)
          break
        case 'arrived':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 3)
          break
        case 'cancelled':
          this.$set(this.pageConfig, 'Steps', [this.defaultSteps[0], { key: 'fail', title: '已取消', state: 'failure' }])
          this.$set(this.pageConfig, 'Step', 2)
          break
      }
    },
  },
  components: {
    DetailPageLayout,
  },
  filters: {
    returnNull: function(value) {
      if (value === null) {
        return '-'
      } else {
        return value
      }
    },
  },
}
</script>
<style scoped>
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
  width: 90px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 33.33%;
}
.status{
  color: red;
}
</style>



// WEBPACK FOOTER //
// LogisticsDetailPage.vue?1a7178b1